<template>
  <div class="about">
    <div class="top">
      <div class="top_title">知识分享</div>
      <div>
        <current-path v-model="ss">
           <template slot="fatherPath">
            首页
          </template>
          <template slot="sonPath">
            知识分享
          </template>
        </current-path>
      </div>
    </div>
    <div class="contentList">
      <news-list-item :data='list1'></news-list-item>
      <news-list-item :data='list2'></news-list-item>
      <news-list-item :data='list3'></news-list-item>
    </div>
  </div>
</template>
<script>
import CurrentPath from '../../components/CurrentPath.vue'
import NewsListItem from '@/components/newsComponentsItem/NewsListItem'
export default {
  components: { CurrentPath, NewsListItem },
  data () {
    return {
      ss: true,
      currentTab: 1, // 默认公司简介
      list1: {
        id: 333,
        imgSrc: require ('@/assets/home/u176.png'),
        date: '2018-08-06 15:47:49',
        seer: '18',
        title: '银保监会发布《关于做好2019年银行业保险业服务乡村振兴和助力脱贫攻坚工作的通知》',
        content: '根据中央经济工作会议和中央农村工作会议精神，按照党中央、国务院实施乡村振兴战略和打赢脱贫攻坚战等有关安排部署，银保监会近日发布《关于做好2019年银行业保险业服务乡村振兴和助力脱贫攻坚工作的通知》（以下简称《通知》），推动解决当前“三农”和扶贫金融服务难点。...'
      },
      list2: {
        id: 334,
        imgSrc: require ('@/assets/home/u172.png'),
        title: '强化底线思维和风险意识 坚决打好防范化解重大金融风险攻坚战',
        date: '2018-08-08 15:00:00',
        seer: '19',
        content: '2019年2月21日，人民银行2019年金融稳定工作会议在成都召开。会议以习近平新时代中国特色社会主义思想为指导，深入学习党的十九大和中央经济工作会议精神……'
      },
      list3: {
        id: 335,
        imgSrc: require ('@/assets/home/u174.png'),
        date: '2018-08-08 16:40:33',
        seer: '16',
        title: '商业保理和银行保理的区别',
        content: '银行保理侧重于融资，因此银行在办理保理业务时，不仅卖家需要有良好的财务数据和交易信息，还需要足够的抵押担保支持，以及符合银行要求的资金用途，同时还须占用企业在银行的授信额度，一般需要较长的流程和时间。所以银行保理更适用于有足够抵押和良好资质的大型企业，中小企业通常达不到银行的标准……'
      },
    }
  },
  methods: {
    changeTab (index) {
      this.currentTab = index
    }
  }
}
</script>
<style lang="stylus" scoped>
.about
  width 1200px
  margin 0 auto
  transform translateY(-40px)
.top
  width 900px
  padding 10px 20px
  background-color #ffffff
  margin 0 auto
  overflow hidden
  display flex
  justify-content space-between
  .top_title
    font-size 18px
    width 100px
    padding-bottom 10px
    border-bottom 1px solid #008000
.about_tab
  display flex
  justify-content flex-start
  margin-top 10px
  border-bottom 1px solid #CCCCCC
  padding-bottom: 20px;
  div
    padding 10px 20px
    font-size 18px
.activeTab
  background-color #E6AC00
  color #ffffff
  position relative
  &::after
    content ''
    display block
    position absolute
    width:0;
    height:0;
    border-width:7px 7px 0;
    border-style:solid;
    border-color:#E6AC00 transparent transparent;/*灰 透明 透明 */
    left 48px
    bottom -7px
.about_content
  margin-top 20px
  font-size 16px
  line-height 32px
  min-height 200px
  .idtent
    text-indent 32px

.contentList
  margin-top 20px
</style>
